













































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { IPostSearch } from '@/_store/models'
import { Meta } from '@sophosoft/vue-meta-decorator'
import { mapActions, mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters(['StatePublicFeed', 'StatePublicLoading']),
  },
  methods: {
    ...mapActions(['GetPublicFeed']),
  },
})
export default class PublicFeed extends Vue {
  StatePublicFeed!: any
  StatePublicLoading!: boolean
  GetPublicFeed!: Function
  @Meta
  getMetaInfo() {
    return {
      title: 'Public Feed',
    }
  }
  search_string: string = ''
  search_string_display: string = ''
  searched_string: boolean = false
  toPage: number = 1
  submitted: boolean = false
  sortOptions = [
    {
      key: 'updated_at',
      value: 'Recently Updated',
    },
    {
      key: 'created_at',
      value: 'Newest',
    },
  ]
  sort_by: string = this.sortOptions[0]['key']
  post_search: IPostSearch = {
    sort_by: this.sort_by,
    toPage: this.toPage,
    search: this.search_string,
  }

  get posts() {
    return this.StatePublicFeed
  }

  get loading() {
    return this.StatePublicLoading
  }

  get isMobile() {
    return this.$isMobile()
  }

  getPublicFeed() {
    if (this.searched_string) {
      this.search_string_display = this.search_string
    }
    return this.GetPublicFeed({
      sort_by: this.sort_by,
      page: this.toPage,
      search: this.search_string,
    })
  }

  search() {
    if (
      (this.search_string !== '' ||
        this.search_string !== undefined ||
        this.search_string !== null) &&
      this.search_string.length >= 4
    ) {
      this.toPage = 1
      this.searched_string = true
      this.getPublicFeed()
    } else {
      return
    }
  }

  subPage() {
    if (this.posts.current_page === 1) {
      return
    } else {
      this.toPage = this.posts.current_page -= 1
      this.getPublicFeed()
    }
  }

  advPage() {
    if (this.posts.current_page === this.posts.total_pages) {
      return
    } else {
      this.toPage = this.posts.current_page += 1
      this.getPublicFeed()
    }
  }

  reset() {
    this.search_string = ''
    this.searched_string = false
    this.getPublicFeed()
  }

  mounted() {
    this.getPublicFeed()
  }
}
